// BEERegistration.jsx
import React from "react";

export default function BEERegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            BEE Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            BEE Registration for Energy Efficiency Compliance
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides assistance for BEE Registration for
            energy efficiency compliance of appliances, equipment, and industrial
            systems under Bureau of Energy Efficiency standards.
          </p>
          <p className="text-gray-700">
            From product classification and accredited testing coordination to
            online registration through BEE portal and star rating label
            approval, the process ensures mandatory energy compliance for market
            access.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/414837/pexels-photo-414837.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Energy efficient appliances BEE star rating compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for BEE Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps manufacturers organize technical and
              test documentation required for BEE registration and star rating
              certification.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Product details including model specifications, energy
                  consumption parameters, and applicable standards.
                </li>
                <li>
                  Test reports from BEE-recognized NABL accredited laboratories
                  confirming energy efficiency performance.
                </li>
                <li>
                  Manufacturer information including company registration,
                  authorized Indian representative details, and manufacturing
                  facility information.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in BEE compliance with technical expertise in
              energy efficiency standards and registration processes.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Energy Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep knowledge of BEE standards, star rating schemes,
                  applicable products list, and mandatory registration
                  requirements across appliances and industrial equipment.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Systematic preparation of product data sheets, test report
                  validation, and BEE portal registration with complete
                  documentation packages.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from product classification and lab testing
                  coordination through BEE approval, label compliance, and
                  ongoing registration maintenance requirements.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
